var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "alerts" },
    _vm._l(_vm.list, function (alert, index) {
      return _c(
        "v-alert",
        {
          key: index,
          staticClass: "my-4",
          class: `text--${alert.textColor || "white"}`,
          attrs: {
            border: "top",
            dismissible: "",
            dark: !alert.textColor || alert.textColor === "white",
            color: alert.type,
            elevation: "4",
            value: alert.show,
            icon: alert.largeIcon ? false : _vm.getIcon(alert),
          },
        },
        [
          _c(
            "div",
            { staticClass: "d-flex align-center" },
            [
              alert.largeIcon
                ? _c(
                    "v-icon",
                    {
                      staticClass: "mr-4",
                      attrs: { size: "48", color: alert.textColor || "white" },
                    },
                    [_vm._v(" " + _vm._s(_vm.getIcon(alert)) + " ")]
                  )
                : _vm._e(),
              _c("div", [
                typeof alert.message === "object"
                  ? _c("div", [
                      _c(
                        "div",
                        { staticClass: "alert-title font-weight-bold" },
                        [_vm._v(" " + _vm._s(alert.message.title) + " ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "alert-description" },
                        _vm._l(
                          _vm.getDescriptionParts(alert),
                          function (part, idx) {
                            return _c(
                              "span",
                              { key: idx },
                              [
                                typeof part === "string"
                                  ? [_vm._v(" " + _vm._s(part) + " ")]
                                  : [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "alert-link",
                                          attrs: { to: part.to },
                                        },
                                        [_vm._v(" " + _vm._s(part.text) + " ")]
                                      ),
                                    ],
                              ],
                              2
                            )
                          }
                        ),
                        0
                      ),
                    ])
                  : _c("div", [_vm._v(" " + _vm._s(alert.message) + " ")]),
                _vm.responseMessage(alert.response)
                  ? _c("span", [
                      _vm._v(" – " + _vm._s(alert.response.data.message) + " "),
                    ])
                  : _vm._e(),
              ]),
            ],
            1
          ),
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }